import { Injectable } from '@angular/core';
import {
	ICmmsEntitiesList,
	IEntityNames,
} from '@app/pages/cmms/components/table-elements/interfaces/interfaces';
import { TableType } from '@app/pages/cmms/types';
import { BehaviorSubject, Subject } from 'rxjs';

const TABLE_TYPE_TRANSLATOR = {
	Asset: TableType.ASSETS,
	'Work Order': TableType.WORK_ORDER,
	Incident: TableType.INCIDENTS,
	Request: TableType.REQUESTS,
	File: TableType.FILES,
};

@Injectable({
	providedIn: 'root',
})
export class ActionCenterService {
	// For now this service will only inform that the action center has done an action
	constructor() {}

	selectedEntities: ICmmsEntitiesList = [];
	actionDone$ = new Subject<void>();
	applyAction$ = new Subject<void>();
	enableApplyButton$ = new Subject<boolean>();
	closeActionCenter$ = new Subject<void>();
	ongoingSuggestionAnalyze$ = new BehaviorSubject<boolean>(false);
	tableType = new BehaviorSubject<TableType>(null);

	setTableType(entityType: IEntityNames) {
		this.tableType.next(TABLE_TYPE_TRANSLATOR[entityType]);
	}
}
